import PropTypes from 'prop-types';
import React from 'react';

export const CONTEXT_DEFAULTS = {};

export const FeatureFlagsContext = React.createContext(CONTEXT_DEFAULTS);

const FeatureFlagsProvider = ({ children, value }) => (
  <FeatureFlagsContext.Provider value={value}>
    {children}
  </FeatureFlagsContext.Provider>
);

FeatureFlagsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({})
};

FeatureFlagsProvider.defaultProps = {
  value: CONTEXT_DEFAULTS
};
export default FeatureFlagsProvider;
